module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_8019.c8e5c94f.png";